import { Loading } from 'module/ui/components/atoms/loading';
import { CustomSectionAttributes } from 'api/custom-section/types';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  SectionTitle,
  SectionTableContainer,
  GeneratedSectionPreview,
} from 'components/organisms/document-editor/extensions/custom-section/ui/shared/section-styles';
import { SharedDetailBlockComponentProps } from './types';
import { FieldsTable } from '../../shared/fields-table';
import { filterableFieldsFromFieldNames } from '../../shared/response-renderer-utils';

export const SharedDetailBlockGeneratedSection = <
  T extends CustomSectionAttributes,
>({
  node,
  sourceType,
  useFieldsHook,
  defaultTitleKey,
  responseToLookupFunction,
}: SharedDetailBlockComponentProps<T>) => {
  const { fields: sourceFields, loading: isLoading } = useFieldsHook();
  const response = (node.attrs as any).response;
  const configFields = useMemo(
    () => (node.attrs as any).config?.fields ?? [],
    [node.attrs],
  );

  const responseLookup = useMemo(
    () => (response != null ? responseToLookupFunction(response) : {}),
    [response, responseToLookupFunction],
  );

  const configuredFields = useMemo(
    () =>
      filterableFieldsFromFieldNames(
        configFields,
        sourceFields ?? [],
        response?.fields ?? [],
        sourceType,
      ),
    [sourceFields, configFields, response?.fields, sourceType],
  );

  return (
    <GeneratedSectionPreview
      isEditable={false}
      isLoading={isLoading}
      isGenerated={true}
    >
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <SectionTitle>
            <FormattedMessage
              id={defaultTitleKey}
              defaultMessage={defaultTitleKey}
            />
          </SectionTitle>
          <SectionTableContainer>
            <FieldsTable
              fields={configuredFields}
              responsesLookup={responseLookup}
            />
          </SectionTableContainer>
        </>
      )}
    </GeneratedSectionPreview>
  );
};
